import { useState } from 'react';
import { motion } from 'framer-motion';
import toast from 'react-hot-toast';
import { industryService, Industry } from '../../services/industryService';
import IndustryForm from './components/IndustryForm.tsx';

const IndustryManager = () => {
  const [industries, setIndustries] = useState<Industry[]>(industryService.getIndustries());
  const [editingIndustry, setEditingIndustry] = useState<Industry | null>(null);
  const [showForm, setShowForm] = useState(false);

  const handleSubmit = (data: Industry) => {
    try {
      industryService.updateIndustry(data);
      setIndustries(industryService.getIndustries());
      setShowForm(false);
      setEditingIndustry(null);
      toast.success('Métier sauvegardé avec succès !');
    } catch (error) {
      toast.error('Erreur lors de la sauvegarde du métier');
      console.error('Error saving industry:', error);
    }
  };

  const handleDelete = (id: string) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer ce métier ?')) {
      industryService.deleteIndustry(id);
      setIndustries(industryService.getIndustries());
      toast.success('Métier supprimé avec succès !');
    }
  };

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-8">
        <h2 className="text-2xl font-bold">Gestion des Métiers</h2>
        <button
          onClick={() => {
            setEditingIndustry(null);
            setShowForm(true);
          }}
          className="bg-neon-orange text-white px-4 py-2 rounded-lg hover:bg-[#FF4500] transition-colors"
        >
          Nouveau Métier
        </button>
      </div>

      {/* Industries Grid */}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {industries.map((industry) => (
          <motion.div
            key={industry.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-white rounded-xl shadow-lg overflow-hidden"
          >
            <div className="p-6">
              <div className="flex items-center gap-3 mb-4">
                <span className="text-3xl">{industry.icon}</span>
                <h3 className="text-xl font-semibold">{industry.name}</h3>
              </div>
              <p className="text-gray-600 mb-4">{industry.description}</p>
              <div className="flex justify-between items-center mb-4">
                <span className="text-sm text-gray-500">{industry.stats.clients}+ clients</span>
                <span className="text-sm text-gray-500">{industry.stats.successRate} satisfaction</span>
              </div>
              <div className="flex gap-2">
                <button
                  onClick={() => {
                    setEditingIndustry(industry);
                    setShowForm(true);
                  }}
                  className="flex-1 bg-gray-100 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-200 transition-colors"
                >
                  Modifier
                </button>
                <button
                  onClick={() => handleDelete(industry.id)}
                  className="flex-1 bg-red-100 text-red-700 px-4 py-2 rounded-lg hover:bg-red-200 transition-colors"
                >
                  Supprimer
                </button>
              </div>
            </div>
          </motion.div>
        ))}
      </div>

      {/* Edit/Create Form Modal */}
      {showForm && (
        <IndustryForm
          initialData={editingIndustry || undefined}
          onSubmit={handleSubmit}
          onCancel={() => {
            setShowForm(false);
            setEditingIndustry(null);
          }}
        />
      )}
    </div>
  );
};

export default IndustryManager;